module.exports = __webpack_public_path__ + "media/reskin-images/icon--play-circle-purple-f122d214.svg";